import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "overflow-x-auto rounded-lg border border-gray-lp-1600 mt-2" }
const _hoisted_2 = { class: "w-full table-auto border-collapse" }
const _hoisted_3 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "bg-gray-lp-2800 text-10px text-black-lp-100" }, [
    /*#__PURE__*/_createVNode("th", { class: "w-16 px-4 py-3 text-left font-semibold" }, " No. "),
    /*#__PURE__*/_createVNode("th", { class: "w-56 px-4 py-3 text-left font-semibold" }, " Negara tujuan "),
    /*#__PURE__*/_createVNode("th", { class: "w-56 px-4 py-3 text-left font-semibold" }, " Min. harga barang "),
    /*#__PURE__*/_createVNode("th", { class: "w-56 px-4 py-3 text-left font-semibold" }, " Maks. harga barang "),
    /*#__PURE__*/_createVNode("th", { class: "w-56 px-4 py-3 text-left font-semibold" }, " Min. biaya COD "),
    /*#__PURE__*/_createVNode("th", { class: "w-32 px-4 py-3 text-left font-semibold" }, " Komisi COD POS Tujuan "),
    /*#__PURE__*/_createVNode("th", { class: "w-24 px-4 py-3 text-left font-semibold" })
  ])
], -1)
const _hoisted_4 = { class: "px-1.5 py-3 text-black-lp-100 align-middle" }
const _hoisted_5 = { class: "flex h-9 items-center justify-center" }
const _hoisted_6 = { class: "px-1.5 py-3" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "p-1.5" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "p-1.5" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "p-1.5" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "p-1.5" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { class: "p-1.5" }
const _hoisted_17 = { class: "p-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "Tambah", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_DataWrapper, {
      label: "Konfigurasi COD",
      class: "w-full"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("table", _hoisted_2, [
            _hoisted_3,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: row.uid,
                  class: "border-t border-gray-lp-1600 align-top"
                }, [
                  _createVNode("td", _hoisted_4, [
                    _createVNode("div", _hoisted_5, _toDisplayString(index + 1), 1)
                  ]),
                  _createVNode("td", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_SelectSearch, {
                        options: _ctx.availableCountryOptions(row),
                        modelValue: _ctx.selectedCountry(row),
                        keyName: "name",
                        keyValue: "id",
                        serverSide: false,
                        isLoading: _ctx.isLoadingCountry,
                        errorCaption: _ctx.countryError(row),
                        isShowErrorIndicator: !!_ctx.countryError(row),
                        isShowErrorMessage: "",
                        hideErrorIcon: "",
                        placeholder: "Pilih negara tujuan",
                        "onUpdate:modelValue": ($event: any) => (_ctx.onSelectCountry($event, row.uid)),
                        onBlur: ($event: any) => (row.countryTouched = true)
                      }, null, 8, ["options", "modelValue", "isLoading", "errorCaption", "isShowErrorIndicator", "onUpdate:modelValue", "onBlur"])
                    ])
                  ]),
                  _createVNode("td", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_LpInput, {
                        modelValue: row.minPrice,
                        "onUpdate:modelValue": ($event: any) => (row.minPrice = $event),
                        prefix: row.currencySymbol || '-',
                        format: (v) => _ctx.formatCountryMoney(v, row.currencyCode),
                        error: !!_ctx.minPriceError(row),
                        errorCaption: _ctx.minPriceError(row),
                        sizeInput: "12px",
                        placeholder: "0",
                        isErrorIconInput: false,
                        isErrorIconCaption: false,
                        onBlur: ($event: any) => (row.minPriceTouched = true)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "prefix", "format", "error", "errorCaption", "onBlur"])
                    ])
                  ]),
                  _createVNode("td", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_LpInput, {
                        modelValue: row.maxPrice,
                        "onUpdate:modelValue": ($event: any) => (row.maxPrice = $event),
                        prefix: row.currencySymbol || '-',
                        format: (v) => _ctx.formatCountryMoney(v, row.currencyCode),
                        error: !!_ctx.maxPriceError(row),
                        errorCaption: _ctx.maxPriceError(row),
                        sizeInput: "12px",
                        placeholder: "0",
                        isErrorIconInput: false,
                        isErrorIconCaption: false,
                        onBlur: ($event: any) => (row.maxPriceTouched = true)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "prefix", "format", "error", "errorCaption", "onBlur"])
                    ])
                  ]),
                  _createVNode("td", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_LpInput, {
                        modelValue: row.minCodFee,
                        "onUpdate:modelValue": ($event: any) => (row.minCodFee = $event),
                        prefix: row.currencySymbol || '-',
                        format: (v) => _ctx.formatCountryMoney(v, row.currencyCode),
                        error: !!_ctx.minCodFeeError(row),
                        errorCaption: _ctx.minCodFeeError(row),
                        sizeInput: "12px",
                        placeholder: "0",
                        isErrorIconInput: false,
                        isErrorIconCaption: false,
                        onBlur: ($event: any) => (row.minCodFeeTouched = true)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "prefix", "format", "error", "errorCaption", "onBlur"])
                    ])
                  ]),
                  _createVNode("td", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_LpInput, {
                        modelValue: row.posDeliveryCommissionPercentage,
                        "onUpdate:modelValue": ($event: any) => (row.posDeliveryCommissionPercentage = $event),
                        suffix: row.currencySymbol ? '%' : '-',
                        format: (v) => _ctx.formatCountryMoney(v, row.currencyCode),
                        error: !!_ctx.commissionError(row),
                        errorCaption: _ctx.commissionError(row),
                        sizeInput: "12px",
                        placeholder: "0",
                        isErrorIconInput: false,
                        isErrorIconCaption: false,
                        onBlur: ($event: any) => (row.posDeliveryCommissionPercentageTouched = true)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "suffix", "format", "error", "errorCaption", "onBlur"])
                    ])
                  ]),
                  _createVNode("td", _hoisted_16, [
                    (_ctx.rows.length > 1)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "flex h-12 cursor-pointer items-center justify-center",
                          onClick: ($event: any) => (_ctx.removeRow(row.uid))
                        }, [
                          _createVNode(_component_Icons, {
                            name: "white-trash",
                            class: "w-4 text-red-lp-100"
                          })
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("button", {
              type: "button",
              class: "flex items-center gap-x-1 text-14px text-red-lp-100 cursor-pointer font-semibold",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
            }, [
              _createVNode(_component_Icons, {
                name: "plus",
                class: "w-4"
              }),
              _hoisted_18
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}